import styled from 'styled-components';
import React from 'react';

import { MultiOutput } from '../common/MultiInput';

const DriveSummaryTriple = ({ drives }) => {
    if (!drives) {
        return;
    }

    return (
        <Wrapper>
            <Title>
                <h3>Drive Summary</h3>
            </Title>
            <Content>
                <MultiOutput
                    label="Drive Description"
                    variable="-"
                    unit="-"
                    variableName="description"
                    // values={[firstDrive.description, secondDrive.description]}
                    values={drives.map((drive) => drive.description)}
                />
                <MultiOutput
                    label="Power(Tension) Distribution (합계 100%)"
                    variable="-"
                    unit="%"
                    variableName="distribution"
                    // values={[firstDrive.distribution, secondDrive.distribution]}
                    values={drives.map((drive) => drive.distribution)}
                />
                <MultiOutput
                    label="Actual Power"
                    variable="Pa"
                    variableName="actualPower"
                    unit="kW"
                    // values={[firstDrive.actualPower, secondDrive.actualPower]}
                    values={drives.map((drive) => drive.actualPower)}
                />
                <MultiOutput
                    label="Mechanical Efficiency"
                    variable="etha"
                    unit="-"
                    variableName="mechanicalEfficiency"
                    // values={[firstDrive.mechanicalEfficiency, secondDrive.mechanicalEfficiency]}
                    values={drives.map((drive) => drive.mechanicalEfficiency)}
                />
                <MultiOutput
                    label="Motor Power Required"
                    variable="PM"
                    variableName="requiredPower"
                    unit="kW"
                    // values={[firstDrive.requiredPower, secondDrive.requiredPower]}
                    values={drives.map((drive) => drive.requiredPower)}
                />
                <MultiOutput
                    label="Motor Selected"
                    variable="-"
                    variableName="selectedMotor"
                    unit="kW"
                    // values={[firstDrive.selectedMotor, secondDrive.selectedMotor]}
                    values={drives.map((drive) => drive.selectedMotor)}
                />
                <MultiOutput
                    label="Effective Tension"
                    variable="Te"
                    unit="N"
                    variableName="effectiveTension"
                    // values={[firstDrive.effectiveTension?.load, secondDrive.effectiveTension?.load]}
                    values={drives.map((drive) => drive.effectiveTension?.load)}
                />
                <MultiOutput
                    label="Wrap Angle"
                    variable="theta"
                    unit="deg"
                    variableName="wrapAngle"
                    // values={[firstDrive.wrapAngle, secondDrive.wrapAngle]}
                    values={drives.map((drive) => drive.wrapAngle)}
                />
                <MultiOutput
                    label="Firction Coefficient between Pulley Lagging and Belt"
                    variable="mu"
                    unit="-"
                    variableName="frictionCoeff"
                    // values={[firstDrive.frictionCoeff, secondDrive.frictionCoeff]}
                    values={drives.map((drive) => drive.frictionCoeff)}
                />
                <MultiOutput
                    label="Max. Transmission Ratio" // 주어진 WrapAngle과 Friction Factor에 따른 본 풀리에서 전달할 수 있는 최대 T1/T2 비율.
                    variable="-"
                    unit="-"
                    variableName="-"
                    // values={[firstDrive.emutheta, secondDrive.emutheta]}
                    values={drives.map((drive) => drive.emutheta)}
                />
                <MultiOutput
                    label="Driving Factor"
                    variable="-"
                    unit="-"
                    variableName="drivingFactor"
                    // values={[firstDrive.drivingFactor, secondDrive.drivingFactor]}
                    values={drives.map((drive) => drive.drivingFactor)}
                />
                <MultiOutput
                    label="Minimum Slackside Tension to Transmit Effective Tension"
                    variable="F2"
                    unit="N"
                    variableName="requiredSlackSideTension"
                    // values={[firstDrive.requiredSlackSideTension, secondDrive.requiredSlackSideTension]}
                    values={drives.map((drive) => drive.requiredSlackSideTension?.load)}
                />
                <MultiOutput
                    isSub
                    label="Permissible Slack Rate between the Idlers(0.05 ~ 0.02)"
                    variable="h/a"
                    variableName="permissibleSagRatio"
                    unit="-"
                    // values={[firstDrive.permissibleSagRatio, secondDrive.permissibleSagRatio]}
                    values={drives.map((drive) => drive.permissibleSagRatio)}
                />
                <MultiOutput
                    label="Minimum Belt Tension Required to limit the Sag"
                    variable="Fmin"
                    variableName="minSagTension"
                    unit="N"
                    // values={[firstDrive.minSagTension, secondDrive.minSagTension]}
                    values={drives.map((drive) => drive.minSagTension?.load)}
                />
                <MultiOutput
                    isSub
                    label="Carry Side"
                    variable="FminC"
                    variableName="minCarry"
                    unit="N"
                    // values={[firstDrive.minCarry, secondDrive.minCarry]}
                    values={drives.map((drive) => drive.minCarry?.load)}
                />
                <MultiOutput
                    isSub
                    label="Return Side"
                    variable="FminR"
                    variableName="minReturn"
                    unit="N"
                    // values={[firstDrive.minReturn, secondDrive.minReturn]}
                    values={drives.map((drive) => drive.minReturn?.load)}
                />
                <MultiOutput
                    label="Return-side Belt Tension (at Head due to Slope)"
                    variable="F3"
                    variableName="slopeTensionReturn"
                    unit="N"
                    // values={[firstDrive.slopeTensionReturn, secondDrive.slopeTensionReturn]}
                    values={drives.map((drive) => drive.slopeTensionReturn?.load)}
                />
                <MultiOutput
                    label="Max. Tension"
                    variable="Fmax"
                    variableName="maxTension"
                    unit="N"
                    // values={[firstDrive.maxTension, secondDrive.maxTension]}
                    values={drives.map((drive) => drive.maxTension)}
                />
                <MultiOutput
                    label="Fmax = FU + F2"
                    variable=""
                    variableName="maxTension1"
                    unit="N"
                    // values={[firstDrive.maxTension1, secondDrive.maxTension1]}
                    isSub
                    values={drives.map((drive) => drive.maxTension1)}
                />
                <MultiOutput
                    label="Fmax = FU + Fmin"
                    variable=""
                    variableName="maxTension2"
                    unit="N"
                    // values={[firstDrive.maxTension2, secondDrive.maxTension2]}
                    isSub
                    values={drives.map((drive) => drive.maxTension2)}
                />
                <MultiOutput
                    label="Fmax = FU + Fmin + F3"
                    variable=""
                    variableName="maxTension3"
                    unit="N"
                    // values={[firstDrive.maxTension3, secondDrive.maxTension3]}
                    isSub
                    values={drives.map((drive) => drive.maxTension3)}
                />
                <MultiOutput
                    label="T1 / T2 Ratio"
                    variable="-"
                    unit="-"
                    variableName="ratio"
                    // values={[firstDrive.ratio, secondDrive.ratio]}
                    values={drives.map((drive) => drive.ratio)}
                />
                <MultiOutput
                    label="Tight Side Tension"
                    variable="T1"
                    unit="N"
                    variableName="tightSideTension"
                    // values={[firstDrive.tightSideTension?.load, secondDrive.tightSideTension?.load]}
                    values={drives.map((drive) => drive.tightSideTension?.load)}
                />
                <MultiOutput
                    label="Slack Side Tension"
                    variable="T2"
                    unit="N"
                    variableName="slackSideTension"
                    // values={[firstDrive.slackSideTension?.load, secondDrive.slackSideTension?.load]}
                    values={drives.map((drive) => drive.slackSideTension?.load)}
                />
            </Content>
        </Wrapper>
    );
};

export default DriveSummaryTriple;

/* =================   Styles   ================== */
const Wrapper = styled.div``;
const Title = styled.div``;
const Content = styled.div``;

